import { Component } from '@angular/core';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { AbstractFinanceFromComponent } from './from/abstract-v12-retail-finance-from.component';

@Component({
    selector: 'v12-retail-finance-from-plp',
    templateUrl: 'v12-retail-finance-from-plp.html',
    styleUrls: ['v12-retail-finance-from-plp.scss'],
    standalone: true,
    imports: [ICmsClientModule, PriceComponent, SizeClassDirective, TranslationModule,]
})
export class FinanceFromPlpComponent extends AbstractFinanceFromComponent {
    isTooltipVisible = false;

    showTooltip() {
        this.isTooltipVisible = true;
        this.detectChanges();
    }

    hideTooltip() {
        this.isTooltipVisible = false;
        this.detectChanges();
    }

    detectChanges() {
        this.changeDetectionRef.detectChanges();
    }
}
